export function normalizeErrorFields(errors: any, setError: any) {
    Object.keys(errors.errors).forEach((fieldName) => {
        setError(fieldName, { type: 'server', message: errors.errors[fieldName][0] });
    });
}